import { type Blocker, type BlockerFunction, useBlocker } from 'react-router'
import { useCallback, useEffect, useRef } from 'react'

export function useBlockerAndUnload(props: {
  isExistChanges: boolean
  handleShowBlockerModal: (blocker: Blocker) => void
  shouldBlock?: BlockerFunction
}) {
  const { isExistChanges, handleShowBlockerModal } = props
  const propsRef = useRef(props)
  propsRef.current = props
  const blocker = useBlocker((args) => {
    const { isExistChanges, shouldBlock } = propsRef.current
    if (!isExistChanges) return false
    if (shouldBlock) return shouldBlock(args)
    return true
  })

  const beforeUnloadHandler = useCallback((event: BeforeUnloadEvent) => {
    event.preventDefault()
  }, [])

  useEffect(() => {
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [])

  useEffect(() => {
    if (blocker.state === 'blocked') {
      handleShowBlockerModal(blocker)
    }
  }, [blocker])

  useEffect(() => {
    if (isExistChanges) {
      window.addEventListener('beforeunload', beforeUnloadHandler)
    } else {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [isExistChanges])
  return { blocker }
}
